export const SEARCH_TYPES = {
  CONTACT: 1,
  SUBMISSION: 2,
};

export const PROFILE_FIELDS_CONFIG = {
  [SEARCH_TYPES.CONTACT]: [

    {
      id: 'firstName',
      label: 'firstName',
      type: 'text',
      required: true,
      placeholder: 'firstNamePlaceholder',
    },
    {
      id: 'lastName',
      label: 'lastName',
      type: 'text',
      required: true,
      placeholder: 'lastNamePlaceholder',
    },
    {
      id: 'email',
      label: 'email',
      type: 'email',
      required: true,
      placeholder: 'emailPlaceholder',
    },
    {
      id: 'phone',
      label: 'phone',
      type: 'tel',
      required: false,
      placeholder: 'phonePlaceholder',
    },
    {
      id: 'company',
      label: 'company',
      type: 'text',
      required: false,
      placeholder: 'companyPlaceholder',
    },
    {
      id: 'position',
      label: 'position',
      type: 'text',
      required: false,
      placeholder: 'positionPlaceholder',
    }
  ],
  [SEARCH_TYPES.SUBMISSION]: [
    {
      id: 'submissionId',
      label: 'submissionId',
      type: 'text',
      required: true,
      placeholder: 'submissionIdPlaceholder',
    },
    {
      id: 'submissionDate',
      label: 'submissionDate',
      type: 'date',
      required: true,
      placeholder: 'submissionDatePlaceholder',
    },
    {
      id: 'status',
      label: 'status',
      type: 'select',
      required: true,
      options: [
        { value: 'pending', label: 'pending' },
        { value: 'approved', label: 'approved' },
        { value: 'rejected', label: 'rejected' },
        { value: 'under_review', label: 'underReview' },
      ],
    },
    {
      id: 'description',
      label: 'description',
      type: 'textarea',
      required: false,
      placeholder: 'descriptionPlaceholder',
      rows: 4,
    },
    {
      id: 'priority',
      label: 'priority',
      type: 'select',
      required: false,
      options: [
        { value: 'low', label: 'low' },
        { value: 'medium', label: 'medium' },
        { value: 'high', label: 'high' },
        { value: 'urgent', label: 'urgent' },
      ],
    },
  ],
};

export const getProfileFields = (searchType) => {
  return PROFILE_FIELDS_CONFIG[searchType] || [];
};

export const getSearchTypeLabel = (searchType) => {
  const labels = {
    [SEARCH_TYPES.CONTACT]: 'contact',
    [SEARCH_TYPES.SUBMISSION]: 'submission',
  };
  return labels[searchType] || 'unknown';
}; 